<div class="main">
    <div class="information">
        <div class="name">{{ clientDevice.name }}</div>
        <div class="description">{{ clientDevice.description }}</div>
        <div class="ip-address">{{ clientDevice.ipAddress }} - {{ clientDevice.defaultUrl }}</div>
    </div>

    <div class="actions">
        <div (click)="refresh()" class="button">refresh</div>
    </div>

</div>